export default "__VITE_ASSET__D7Ox2GJR__"